import type React from "react";

import { Flexbox, type FlexboxProps } from "./Flexbox";

export type VerticalFlexboxProps<T extends React.ElementType = "div"> = Omit<
  FlexboxProps<T>,
  "flexDirection"
>;

/**
 * A shorthand component for vertical (column) flexbox layouts.
 * Sets flexDirection to "column" by default.
 */
export const VerticalFlexbox = <T extends React.ElementType = "div">(
  props: VerticalFlexboxProps<T>,
) => {
  return <Flexbox<T> {...(props as FlexboxProps<T>)} flexDirection="column" />;
};
